export const INFO_TEXT_TYPE_COLOR = {
  SUCCESS: '#0ABD00',
  WARNING: '#BA6000',
};
